import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { AnalysisResult } from '../../../../../../components/common/AnalysisResult/AnalysisResult';
import { AddressProvider } from '../../../../../../providers/AddressProvider/AddressProvider';

import { useProfileByParamId } from '../../../../../../react-query/profile/useProfile';
import { useProfileUtils } from '../../../../hooks/useProfileUtils';

import {
  ProfileDataCardBase,
  ProfileDataFollowButton,
  ProfileDataPageTitle,
} from '../../components';
import { Container } from '../../../../../../components/layouts/Container';
import { AddressesSelect } from '../../AddressesSelect/AddressesSelect';

export const AddressReputationsView: React.FC = () => {
  const { data: profile } = useProfileByParamId();
  const { t } = useTranslation('common');
  const [addresses, setAddreses] = useState<string[]>();
  const { isOwner, isClaimedAddress } = useProfileUtils();

  useEffect(() => {
    if (profile) setAddreses(profile.addresses);
  }, [profile]);

  if (!profile) return null;

  const onAddressChange = (address: string) => {
    setAddreses(address === 'all' ? profile.addresses : [address]);
  };

  return (
    <>
      <ActionsWrapper>
        <ProfileDataPageTitle>{t('profile')}</ProfileDataPageTitle>
        <AddressesSelect onChange={onAddressChange} />
      </ActionsWrapper>
      <Wrapper>
        {addresses?.map(address => (
          <ProfileDataCardBase key={address}>
            <AddressProvider initAddress={address}>
              <AnalysisResult where='list' />
            </AddressProvider>
            {!isOwner && isClaimedAddress && (
              <ProfileDataFollowButton address={address} />
            )}
          </ProfileDataCardBase>
        ))}
      </Wrapper>
    </>
  );
};

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  width: '100%',
  position: 'relative',
  minHeight: 480,
  [theme.betweenDM]: {
    minHeight: theme.pxToVw(480),
    gap: theme.pxToVw(8),
  },
}));

const ActionsWrapper = styled(Container)(({ theme }) => ({
  marginBottom: 40,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  [theme.min(theme.breakpoints.sm)]: {
    flexDirection: 'row',
    alignitems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  [theme.betweenDM]: {
    marginBottom: theme.pxToVw(16),
    gap: theme.pxToVw(12),
  },
}));
